import { ApiError } from "../api";

/** One Idempotency-Key per submission; kept on network errors so a retry is not charged twice. */
export const newKey = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export const codeOf = (e: unknown) => (e instanceof ApiError ? e.code : "network");
